<template>
  <div class="homeworkQuestion" v-loading="homeworkExerciseBlock">
    <div class="homeworkQuestion_title">{{homeworkExercise.studentExercise.studentName}}的答题卡</div>
    <div class="homeworkQuestion_box">
      <div class="homeworkQuestion_item">
        <div class="homeworkQuestion_item_number_one">{{homeworkExercise.studentExercise.questionNum - homeworkExercise.studentExercise.wrongNum - homeworkExercise.studentExercise.emptyNum}}</div>
        <div class="homeworkQuestion_text">正确</div>
      </div>
      <div class="homeworkQuestion_item">
        <div class="homeworkQuestion_item_number_two">{{homeworkExercise.studentExercise.wrongNum}}</div>
        <div class="homeworkQuestion_text">错误</div>
      </div>
      <div class="homeworkQuestion_item">
        <div class="homeworkQuestion_item_number_three">{{((homeworkExercise.studentExercise.questionNum - homeworkExercise.studentExercise.wrongNum - homeworkExercise.studentExercise.emptyNum)/homeworkExercise.studentExercise.questionNum*100).toFixed(1)}}%</div>
        <div class="homeworkQuestion_text">正确率</div>
      </div>
    </div>
    <div v-for="(item,index) in homeworkExercise.studentExercise.children" :key="index" style="margin-top:20px">
      <div v-if="item.question.mode == '单选'">
        <div>
          {{index + 1}}、 [{{item.question.mode}}]
          <span v-html="item.question.title"></span>
        </div>
        <div class="homeworkQuestion_option" v-for="(items,indexs) in item.question.optionList" :key="indexs">
          <span v-if="item.userAnswer == items.options && item.question.answer == items.options">
            <i class="iconfont icon-zhengque1 homeworkQuestion_icon homeworkQuestion_icon_true"></i>
          </span>
          <span v-else-if="item.userAnswer != items.options && item.question.answer == items.options">
            <i class="iconfont icon-zhengque1 homeworkQuestion_icon homeworkQuestion_icon_true"></i>
          </span>
          <span v-else-if="item.userAnswer == items.options && item.question.answer != items.options">
            <i class="iconfont icon-cuowu homeworkQuestion_icon homeworkQuestion_icon_false"></i>
          </span>
          <span v-else-if="item.userAnswer != items.options && item.question.answer != items.options">
            <i class="iconfont icon-quan homeworkQuestion_icon"></i>
          </span>
          <span style="line-height:23px">
            {{items.options}}、
            <span v-html="items.name"></span>
          </span>
        </div>
      </div>

      <div v-if="item.question.mode == '多选'">
        <div>
          {{index + 1}}、 [{{item.question.mode}}]
          <span v-if="item.ptitle!=null" v-html="item.question.ptitle"></span>
          <span v-html="item.question.title"></span>
        </div>
        <div class="homeworkQuestion_option" v-for="(items,indexs) in item.question.optionList" :key="indexs">
          <span v-if="item.question.answer.indexOf(items.options) > -1">
            <i class="iconfont icon-xuanze-fangkuang-tianchong homeworkQuestion_icon_true"></i>
          </span>
          <span v-else-if="item.question.answer.indexOf(items.options) < 0 && item.userAnswer.indexOf(items.options) > -1">
            <i class="iconfont icon-cuowu-fangkuang-tianchong homeworkQuestion_icon_false"></i>
          </span>
          <span v-else>
            <i class="iconfont icon-fangkuang"></i>
          </span>
          <span style="line-height:23px">
            {{items.options}}、
            <span v-html="items.name"></span>
          </span>
        </div>
      </div>

      <div v-if="item.question.mode == '判断'">
        <div>
          {{index + 1}}、 [{{item.question.mode}}]
          <span v-html="item.question.title"></span>
        </div>
        <div>
          <div class="homeworkQuestion_option">
            <span v-if="item.userAnswer == item.question.answer == '对' || item.question.answer == '对'">
              <i class="iconfont icon-zhengque1 homeworkQuestion_icon homeworkQuestion_icon_true"></i>
            </span>
            <span v-else-if="item.userAnswer == '对' && item.question.answer == '错'">
              <i class="iconfont icon-cuowu homeworkQuestion_icon homeworkQuestion_icon_false"></i>
            </span>
            <span v-else>
              <i class="iconfont icon-quan homeworkQuestion_icon"></i>
            </span>
            <span>对</span>
          </div>
          <div class="homeworkQuestion_option">
            <span v-if="item.userAnswer == item.question.answer == '错' || item.question.answer == '错'">
              <i class="iconfont icon-zhengque1 homeworkQuestion_icon homeworkQuestion_icon_true"></i>
            </span>
            <span v-else-if="item.userAnswer == '错' && item.question.answer == '对'">
              <i class="iconfont icon-cuowu homeworkQuestion_icon homeworkQuestion_icon_false"></i>
            </span>
            <span v-else>
              <i class="iconfont icon-quan homeworkQuestion_icon"></i>
            </span>
            <span>错</span>
          </div>
        </div>
      </div>

      <div v-if="item.question.mode == '填写'">
        <div>
          {{index + 1}}、 [{{item.question.mode}}]
          <span v-html="item.question.title"></span>
        </div>
        <div class="homeworkQuestion_option">
          <span>答案：</span>
          <span v-html="item.question.answer"></span>
        </div>
      </div>

      <div>
        <div class="homeworkQuestion_tab flex-between homeworkQuestion_tab_item" style="margin-top:50px">
          <div v-if="item.question.answer == item.userAnswer" class="homeworkQuestion_tab_true"><i class="iconfont icon-queding homeworkQuestion_icon"></i>回答正确</div>
          <div v-else class="homeworkQuestion_tab_false"><i class="iconfont icon-guanbi homeworkQuestion_icon"></i>回答错误</div>

          <div class="flex-starts" style="flex-wrap:wrap;">
            <div style="margin-right:50px"><span class="homeworkQuestion_tab_title">正确答案：</span><span class="homeworkQuestion_icon_true" v-html="item.question.answer">{{item.question.answer}}</span></div>
            <div ><span class="homeworkQuestion_tab_title">TA的答案：</span><span class="homeworkQuestion_icon_false" v-html="item.userAnswer">{{item.userAnswer}}</span></div>
          </div>
          <!-- <div>收起解析</div> -->
        </div>
        <!-- <div class="homeworkQuestion_tab_item">
          <span class="homeworkQuestion_tab_title">知识点：&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span></span>
        </div>
        <div class="homeworkQuestion_tab_item">
          <span class="homeworkQuestion_tab_title">教材页码：</span>
          <span></span>
        </div> -->
        <div class="flex-starts homeworkQuestion_tab_item">
          <div class="homeworkQuestion_tab_title">试卷难度</div>
          <el-rate disabled v-model="item.question.hard"></el-rate>
        </div>
        <div class="homeworkQuestion_tab_item">
          <span class="homeworkQuestion_tab_title">参考解析：</span>
          <span v-html="item.question.analysis"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      homeworkExerciseBlock: true,
      homeworkExercise: {
        studentExercise: {},
      },
    };
  },
  props: {
    homeworkQuestionData: {},
  },
  computed: {},
  created () { },
  methods: {
    getHomeworkExerciseById () {
      this.homeworkExerciseBlock = true;
      this.api.homework
        .getHomeworkExerciseById(this.homeworkQuestionData)
        .then((result) => {
          if (result.success) {
            this.homeworkExercise = result.data;
            this.homeworkExerciseBlock = false;
          } else {
            this.$message.error(result.message);
          }
        });
    },
  },
  mounted () {
    this.getHomeworkExerciseById();
  },
  watch: {},
};
</script>

<style lang="less" rel="stylesheet/less">
.homeworkQuestion {
  padding-bottom: 20px;
  p {
    display: initial;
  }
  .homeworkQuestion_title {
    font-size: 16px;
  }
  .homeworkQuestion_box {
    border: 1px solid #ccc;
    background-color: #e3e4e6;
    display: flex;
    margin-top: 20px;
  }
  .homeworkQuestion_item {
    flex: 1;
    text-align: center;
    padding-top: 20px;
    padding-bottom: 20px;
  }
  .homeworkQuestion_item_number_one {
    font-size: 28px;
    color: #13b041;
  }
  .homeworkQuestion_item_number_two {
    font-size: 28px;
    color: #ea1a1a;
  }
  .homeworkQuestion_item_number_three {
    font-size: 28px;
    color: #13b041;
  }
  .homeworkQuestion_item_number_four {
    font-size: 28px;
    color: #ea1a1a;
  }
  .homeworkQuestion_text {
    margin-top: 10px;
    color: #a2aabc;
  }
  .homeworkQuestion_icon {
    font-size: 18px;
    margin-right: 5px;
  }
  .homeworkQuestion_icon_false {
    color: rgb(252, 94, 94);
  }
  .homeworkQuestion_icon_true {
    color: rgb(65, 212, 151);
  }
  .homeworkQuestion_option {
    margin-left: 20px;
    margin-top: 20px;
  }
  .homeworkQuestion_tab {
    background-color: #fafafa;
    padding: 10px 20px;
  }
  .homeworkQuestion_tab_title {
    color: #a2aabc;
  }
  .homeworkQuestion_tab_item {
    margin-top: 15px;
    position: relative;
  }
  .homeworkQuestion_tab_true {
    position: absolute;
    top: -32px;
    color: #41d497;
    background-color: #ecfbf4;
    height: 32px;
    width: 120px;
    text-align: center;
    line-height: 32px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    font-size: 16px;
  }
  .homeworkQuestion_tab_false {
    position: absolute;
    top: -32px;
    color: #fc5e5e;
    background-color: #ffefef;
    height: 32px;
    width: 120px;
    text-align: center;
    line-height: 32px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    font-size: 16px;
  }
  .homeworkQuestion_icon {
    margin-right: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/classRoomTeaching/homeworkQuestion.vue